import React, { useState } from "react";
import CustomDiv from "../CustomDiv";
// import brandLogo from "../../Assets/amaka.png";
import SignIn from "../../Authentication/SignInPage";
// import TemporaryDrawer from "./AddToCart";
import { useNavigate } from "react-router-dom";
import Text from "../Text";
import { useMutation, useQuery } from "react-query";
import { myWishList } from "../../Services/WishList";
// import wishlistLogo from "../../Assets/wishlist.svg";
import {
  Autocomplete,
  Badge,
  Box,
  Collapse,
  Drawer,
  List,
  ListItemButton,
  TextField,
  Typography,
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  KeyboardArrowDownOutlined,
  MenuTwoTone,
} from "@mui/icons-material";
import { categoryListFn } from "../../Services/CategoryList";
import { useDispatch } from "react-redux";
import { setThemeMode } from "../../Redux/Actions/ThemeMode";
import { productsFn } from "../../Services/Products";
import aaraclouds from "../../Assets/aaraclouds.png";
import Cart from "./Cart";

const MultiVendorHeader = () => {
  const [open, setOpen] = useState(false);
  const [collapse, setCollapse] = useState([]);
  const [spices, setSpices] = React.useState([]);
  const { mutate: allProducts } = useMutation(productsFn, {
    onSuccess: (response) => {
      setSpices(response.data.data.product_list);
    },
  });

  React.useEffect(() => {
    allProducts();
  }, [""]);

  const products = spices?.map((product) => {
    return {
      image: product.image,
      variant: product.variant_name,
      sub_category: product.sub_category,
      id: product.id,
    };
  });

  const handleClick = (id) => {
    setCollapse((collapse) => [...collapse, id]);
  };
  const handleClose = (id) => {
    setCollapse(collapse.filter((item) => item !== id));
  };
  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(setThemeMode(true));
  };

  const navigate = useNavigate();
  const { data } = useQuery(["wishList"], () => myWishList(), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const { data: mainCategoryList } = useQuery(
    ["mainCategoryList"],
    () => categoryListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  const handleChange = (event) => {
    navigate(`/product/${event.currentTarget.lastChild.innerHTML}`);
    sessionStorage.clear();
    setOpen(false);
  };
  // const theme = createTheme({
  //   palette: {
  //     mode: "light",
  //   },
  // });

  return (
    <CustomDiv className=" lg:h-0 h-[25px] sticky !bg-purple-800 z-50 lg:shadow border-b-2 border-solid border-white">
      <CustomDiv className="flex flex-col justify-between items-center fixed z-50 lg:shadow text-black backdrop-blur-md w-full px-[7%] lg:px-[10%]">
        <CustomDiv className=" flex text-black items-center justify-between w-full">
          <span className="flex items-center">
            <img
              src={aaraclouds}
              alt=""
              className="w-24  bg-white mt-2 p-2 rounded-xl cursor-pointer"
              onClick={() => navigate("/")}
            />
          </span>

          <span className="flex items-center gap-4 lg:gap-7">
            <SignIn />
            <Badge
              badgeContent={
                localStorage.getItem("token")
                  ? data?.data?.data?.wishlist_product_list?.length
                  : 0
              }
              color="primary"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 cursor-pointer"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                onClick={() =>
                  localStorage.getItem("token")
                    ? navigate("/wish-list")
                    : handleLogin()
                }
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                />
              </svg>
            </Badge>
            <Cart />

            <MenuTwoTone
              className="!block cursor-pointer lg:!hidden"
              onClick={() => setOpen(true)}
            />

            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
              <CustomDiv className="">
                <List className="!pr-0">
                  <span className="!p-4 flex justify-center">
                    <Autocomplete
                      options={products}
                      autoHighlight
                      size="small"
                      className="Product"
                      freeSolo
                      sx={{ width: 200 }}
                      onChange={handleChange}
                      disableClearable
                      getOptionLabel={(option) => option.variant}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          <img
                            loading="lazy"
                            width="50"
                            src={option.image}
                            srcSet={option.image}
                            alt=""
                          />
                          <span className="flex flex-col">
                            <span className="text-lg">{option.variant}</span>
                            <span className="text-sm">
                              {option.sub_category}
                            </span>
                          </span>

                          <span id="variant_id" hidden>
                            {option.id}
                          </span>
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search Products"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </span>

                  <ListItemButton
                    onClick={() =>
                      navigate("/all-products", {
                        state: { from: "allproduct" },
                      })
                    }
                    className="!flex !justify-between !w-full"
                  >
                    All Products
                  </ListItemButton>
                  {mainCategoryList?.data?.data?.main_category_list?.map(
                    (product) => {
                      return (
                        <>
                          <ListItemButton
                            onClick={() => {
                              return (
                                <>
                                  {collapse.indexOf(product.id) === -1
                                    ? handleClick(product.id)
                                    : handleClose(product.id)}
                                </>
                              );
                            }}
                            className="!flex !justify-between !w-full"
                          >
                            <span>{product.category}</span>

                            {collapse ? <ExpandMore /> : <ExpandLess />}
                          </ListItemButton>
                          <Collapse
                            in={collapse.indexOf(product.id) !== -1}
                            className=""
                          >
                            <List>
                              {product?.sub_category_list?.map(
                                (subCategory) => {
                                  return (
                                    <ListItemButton
                                      className="!flex !pl-8 !justify-between !w-full"
                                      onClick={() =>
                                        navigate(`/all-products`, {
                                          state: {
                                            from: "subCategory",
                                            subCategory: subCategory.id,
                                          },
                                        })
                                      }
                                    >
                                      <li
                                        className=""
                                        onClick={() =>
                                          subCategory.category ===
                                          "Shared services "
                                            ? navigate("/devops")
                                            : subCategory.category ===
                                              "Dedicated Services "
                                            ? navigate("/dedicated")
                                            : navigate(
                                                `/allproduct/${subCategory?.id}`
                                              )
                                        }
                                      ></li>
                                      {subCategory.subcategory}
                                    </ListItemButton>
                                  );
                                }
                              )}
                            </List>
                          </Collapse>
                        </>
                      );
                    }
                  )}
                </List>
              </CustomDiv>
            </Drawer>
          </span>
        </CustomDiv>
      </CustomDiv>
      <CustomDiv className="hidden lg:flex shadow text-black justify-center gap-10 items-end lg:pt-[135px] h-[70px]">
        <Typography
          onClick={() =>
            navigate("/all-products", {
              state: { from: "allproduct" },
            })
          }
          className="whitespace-nowrap  text-black cursor-pointer hover:bg-gray-200 font-bold py-2 px-4 rounded inline-flex text-2xl items-center"
        >
          <Text>All Products</Text>
        </Typography>
        {mainCategoryList?.data?.data?.main_category_list
          ?.slice(0, 6)
          ?.map((product) => {
            return (
              <div className="group inline-block relative">
                <Typography className="whitespace-nowrap cursor-pointer hover:bg-gray-200 text-black text-2xl font-bold py-2 px-4 rounded inline-flex items-center">
                  <Text>{product.category}</Text> <KeyboardArrowDownOutlined />
                </Typography>
                <ul className="absolute hidden w-96 p-2 z-50 shadow bg-white bg-opacity-80 backdrop-blur text-black border-t-4 border-[#306BDE] rounded-sm group-hover:grid group-hover:grid-cols-2">
                  {product?.sub_category_list?.map((subCategory) => {
                    return (
                      <li
                        key={subCategory.id}
                        className="p-2 flex flex-col gap-2 cursor-pointer hover:underline"
                        onClick={() =>
                          navigate(`/all-products`, {
                            state: {
                              from: "subCategory",
                              subCategory: subCategory.id,
                            },
                          })
                        }
                      >
                        {subCategory.subcategory}
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
      </CustomDiv>
    </CustomDiv>
  );
};

export default MultiVendorHeader;
